// Written by scripts/r2_push.py — do not edit.
// Content digest of the MEDIA in the R2 bucket. Changes when the
// CONTENT changes and not when code changes, which is what lets the
// bucket serve audio immutable. See stamp_media_id.
export const MEDIA_ID = '16c6d6dce03147be';
// Frozen, and no longer a digest. The dicts are served
// must-revalidate now, so freshness comes from the cache header and
// not from this query string. As a digest it actively hurt: it is
// compiled into the JS bundle, so the stamp for an edited dict only
// moved on a REBUILD -- correcting one word meant a deploy, and every
// push dirtied the working tree with a stamp nobody could act on.
export const DICT_ID = 'revalidate';
